export default __webpack_public_path__ + "static/media/storageUnit1-afterA-1440w.54dd5e79.avif";